import api from './api';

export const workingDaysService = {
  // Get current month working days data
  getCurrentMonthWorkingDays: async () => {
    const response = await api.get('/working-days/current');
    return response.data;
  },

  // Get working days data for a specific month
  getWorkingDaysData: async (year, month) => {
    const response = await api.get(`/working-days/${year}/${month}`);
    return response.data;
  }
};


